import {
  Badge,
  Box,
  ButtonLink,
  Columns,
  Column,
  Inline,
  Stack,
  Text,
} from 'braid-design-system';
import type { ReactElement } from 'react';

import { useLocalisedRoutes } from 'src/app/v1/views/hooks/useLocalisedRoutes';
import {
  RECRUITER_NETWORK_BANNER_BUTTON_TEXT,
  RECRUITER_NETWORK_BANNER_SUBTITLE,
  RECRUITER_NETWORK_BANNER_TITLE,
  URL_RECRUITER_NETWORK,
} from 'src/app/v1/views/pages/JobAdBooking/components/RecruiterNetworkBanner/constants';

import srnLogo from './srn-logo.png';
import srnRightImage from './srn-right-image.png';

import * as styles from './index.css';

export const RecruiterNetworkBanner = (): ReactElement => {
  const { resolveUrl } = useLocalisedRoutes();
  const buttonUrl = resolveUrl({ path: URL_RECRUITER_NETWORK, country: 'au' });

  return (
    <Box
      background="surface"
      paddingX="medium"
      paddingY={{
        mobile: 'medium',
        tablet: 'medium',
      }}
      borderRadius="xlarge"
      boxShadow="borderNeutralLight"
    >
      <Stack space="small">
        <Box>
          <Inline space="xsmall" align="left" alignY="center">
            <Box>
              <img src={srnLogo} width={209} />
            </Box>
            <Box paddingBottom="xsmall">
              <Badge tone="positive" bleedY>
                New
              </Badge>
            </Box>
          </Inline>
        </Box>
        <Columns space="medium" reverse collapseBelow="tablet">
          <Column width="content">
            <Box className={styles.srnRightImage}>
              <img src={srnRightImage} width={260} />
            </Box>
          </Column>
          <Column>
            <Stack space="medium">
              <Text size="large" weight="strong">
                {RECRUITER_NETWORK_BANNER_TITLE}
              </Text>
              <Text size="standard">{RECRUITER_NETWORK_BANNER_SUBTITLE}</Text>
              <Inline
                align={{
                  mobile: 'center',
                  tablet: 'left',
                }}
                space="none"
              >
                <ButtonLink href={buttonUrl} variant="solid">
                  {RECRUITER_NETWORK_BANNER_BUTTON_TEXT}
                </ButtonLink>
              </Inline>
            </Stack>
          </Column>
        </Columns>
      </Stack>
    </Box>
  );
};
